<!--Navbar-->
<mdb-navbar SideClass="navbar navbar-dark color-kia fixed-top text-center" [containerInside]="false">
  <mdb-navbar-brand>
    <a class="navbar-brand" href="#">
      <img src="./assets/images/Logo_White.png" height="30" alt="">
    </a>
  </mdb-navbar-brand>
</mdb-navbar>
<!--/.Navbar-->
<main>
  <router-outlet></router-outlet>
</main>
